import type { IAddressRequest, IAddressDTO, ISuggestion, IPartyDTO, IPartyRequest } from './models';

import { KEGatewayClient } from '../KEGatewayClient';

export class _DadataClient extends KEGatewayClient {
  public async getAddressSuggests(data: IAddressRequest): Promise<ISuggestion<IAddressDTO>[]> {
    return this.post<{ suggestions: ISuggestion<IAddressDTO>[] }, IAddressRequest>(
      'dadata/suggest/address',
      data
    ).then((r) => r.suggestions);
  }

  public async getPartySuggests(data: IPartyRequest): Promise<ISuggestion<IPartyDTO>[]> {
    return this.post<{ suggestions: ISuggestion<IPartyDTO>[] }, IPartyRequest>(
      'dadata/suggest/party',
      data
    ).then((r) => r.suggestions);
  }
}

export const DadataClient = new _DadataClient();
